module.exports = "/static/assets/150503fb4db3881f43e910d8ad01a660.png";